import utils from 'libs/utils';
import consts from 'consts';

/**
 * created by zhouzt on 2020-05-25
 *
 * description: 页面继承公共类
 *
 */
class Page {
	/**
	 * description: 构造函数
	 *
	 * created by zhouzt on 2020-05-25
	 *
	 */
	constructor() {
		// 当前 sid
		this.sid = '';

		// 绑定事件
		this.bindPageEvent();
	}

	/**
	 * description: 绑定公共事件
	 *
	 * created by zhouzt on 2020-05-25
	 *
	 */
	bindPageEvent() {
		const that = this;

		// 按钮【切换平台】
		$('body').on('click', '.swith_plats', async function() {
			// 重新赋值 sid
			that.sid = $(this).data('code');
			// 赋值 pageInit 的 sid
			that.pageInit.sid = that.sid;
			// 存入 session 当中
			tools.store.delSS(consts.STORE.PLATSTORE);
			tools.store.setSS(consts.STORE.PLATSTORE, $(this).data('code'));
			// 重新获取审批对象
			await that.pageInit.getCheckCode();

			if(that.switchPlat) {
				that.switchPlat();
			}
		});
	}
}

export default Page;


// WEBPACK FOOTER //
// ./src/template/page/page.js